import { render } from "./LinkToolKid.vue?vue&type=template&id=32c83f3f"
import script from "./LinkToolKid.vue?vue&type=script&lang=js"
export * from "./LinkToolKid.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafepayam-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__